import { initPostHog } from '@cronos-app/analytics';
import { currentWallet } from '@cronos-app/wallet';
import { useRedirectToUserLanguage } from '@ui/locales/browserSSG';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useMount } from 'react-use';

export const useInitializeApp = () => {
  useInitializeWallet();
  useInitializePostHog();
  useRedirectToUserLanguage();
};

const useInitializePostHog = () => {
  const router = useRouter();
  useEffect(() => {
    const posthog = initPostHog();
    if (posthog === undefined) return;

    const handleRouteChange = () => posthog.capture('$pageview');
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);
};

const useInitializeWallet = () => {
  useMount(() => {
    currentWallet.autoConnect();
  });
};
